import * as Firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
import "firebase/firestore";

const config = {
  apiKey: "AIzaSyAbPd0p3Qc4ERROtagJuU2_fsNkd4NsXJE",
  authDomain: "cortexial-app.firebaseapp.com",
  databaseURL: "https://cortexial-app.firebaseio.com",
  projectId: "cortexial-app",
  storageBucket: "cortexial-app.appspot.com",
  messagingSenderId: "767580810580"
};

const FirebaseApp = Firebase.initializeApp(config);
const FirebaseAuth = FirebaseApp.auth();
const FirebaseDb = FirebaseApp.firestore(); // https://firebase.google.com/docs/firestore/manage-data/enable-offline
const FirebaseStorage = {
  init(uid) {
    this.storage = FirebaseApp.storage();
    this.ref = this.storage.ref();
    this.images = this.ref.child(`${uid}/images`);
    this.videos = this.ref.child(`${uid}/videos`);
  },
  images: null,
  videos: null,
  storage: null,
  ref: null
};
/* const FirebaseStorage = {
  init(uid) {
    this.storage = FirebaseApp.storage(`gs://${uid}`);
    this.ref = this.storage.ref();
  },
  storage: null,
  ref: null
}; */

const batch = FirebaseDb.batch();

const dbProfile = FirebaseDb.collection("profile"); // profile?
const dbProjects = FirebaseDb.collection("projects");
const dbPages = FirebaseDb.collection("pages"); // or as array in project?

FirebaseAuth.setPersistence("local");

export {
  FirebaseApp,
  FirebaseAuth,
  FirebaseStorage,
  FirebaseDb,
  batch,
  dbProfile,
  dbProjects,
  dbPages
};

/* db.enablePersistence().then(function() {
  // Initialize Cloud Firestore through firebase
  var db = firebase.firestore();
}).catch(function(err) {
  if (err.code == 'failed-precondition') {
    // Multiple tabs open, persistence can only be enabled
    // in one tab at a a time.
    // ...
  } else if (err.code == 'unimplemented') {
    // The current browser does not support all of the
    // features required to enable persistence
    // ...
  }
}); */
// https://firebase.google.com/docs/firestore/quickstart?authuser=0



// WEBPACK FOOTER //
// ./src/firebase.js